export default __webpack_public_path__ + "static/media/logo-sauce-red.d6c0ba10.svg";